const _excluded = ["className", "size", "centeredInBox", "centerBoxHeight", "centerBoxWidth", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import cn from 'classnames';
import styles from "./CircularLoader.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CircularLoader(props) {
  const {
      className,
      size = 24,
      centeredInBox,
      centerBoxHeight,
      centerBoxWidth,
      style
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const loader = /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    className: cn(styles.circularLoader, className),
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    style: style
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: "loaderGradient",
        x1: "0%",
        y1: "0%",
        x2: "100%",
        y2: "0%",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0%",
          stopColor: "#643CFF",
          stopOpacity: "1"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "20%",
          stopColor: "#643CFF",
          stopOpacity: "0.8"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "50%",
          stopColor: "#643CFF",
          stopOpacity: "0.5"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "95%",
          stopColor: "#643CFF",
          stopOpacity: "0"
        })]
      })
    }), /*#__PURE__*/_jsx("circle", {
      className: styles.circle,
      cx: "25",
      cy: "25",
      r: "20",
      strokeWidth: "8.5",
      stroke: "url(#loaderGradient)"
    })]
  }));
  return centeredInBox ? /*#__PURE__*/_jsx("div", {
    className: styles.centeredBox,
    style: {
      height: centerBoxHeight,
      width: centerBoxWidth
    },
    children: loader
  }) : loader;
}